import { useSelector } from 'react-redux';

import {
  selectIsRemoteAccessLoading,
  selectIsRemoteAccessValid,
  selectRemoteAccessCustomId,
  selectRemoteAccessError,
  selectRemoteAccessExpiry,
  selectRemoteAccessKey,
  selectRemoteAccessLinks,
  selectRemoteAccessRetries,
} from '@lib/core/retailers/selectors/remoteAccess';

export const useRemoteAccess = () => {
  return {
    isRemoteAccessLoading: useSelector(selectIsRemoteAccessLoading),
    isRemoteAccessValid: useSelector(selectIsRemoteAccessValid),
    remoteAccessCustomId: useSelector(selectRemoteAccessCustomId),
    remoteAccessError: useSelector(selectRemoteAccessError),
    remoteAccessExpiry: useSelector(selectRemoteAccessExpiry),
    remoteAccessKey: useSelector(selectRemoteAccessKey),
    remoteAccessLinks: useSelector(selectRemoteAccessLinks),
    remoteAccessRetries: useSelector(selectRemoteAccessRetries),
  };
};
